import { render } from "./XmlCDataSection.vue?vue&type=template&id=0fce587a&scoped=true"
import script from "./XmlCDataSection.vue?vue&type=script&lang=js"
export * from "./XmlCDataSection.vue?vue&type=script&lang=js"

import "./XmlCDataSection.vue?vue&type=style&index=0&id=0fce587a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fce587a"]])

export default __exports__